<button id="btnHelpMenu" bciIntegratedButton mat-icon-button (click)="onOperationHelp()">
    <mat-icon fontIcon="Bosch-Ic-help"></mat-icon>
</button>
